import React from 'react'

const Cards = ({ category, number, percent, icon, iconColor ,percentColor,previous }) => {
    return (
        <div className='shadow-custom rounded-3xl p-7 w-1/3 md:w-full xs:w-full'>
            <div className='flex flex-row justify-between'>
                <p className='text-base text-black font-semibold'>{category}</p>
                <div className="text-3xl">
                    <span className={`${iconColor}`}>{icon}</span>
                </div>
            </div>
            <div>
                <p className='text-black text-3xl font-bold mt-4'>{number}</p>
            </div>
            <div className='flex flex-row justify-start mt-4 gap-1'>
                <p className='text-sm font-semibold'><span className={`${percentColor}`}>{percent}</span></p>
                <p className='text-sm font-normal text-gray-600'> {previous}</p>
            </div>
        </div>
    )
}

export default Cards